import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Container, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useURLHandler } from 'src/utils/hooks';
import InvoicesTab from './InvoicesTab';
import { PaymentInformationTab } from './PaymentInformationTab';
import { PaymentMethodsGrid } from './PaymentMethods';
import { ReimbursementDetailsTab } from './ReimbursementDetailsTab';
import SubscriptionTab from './SubscriptionTab';
import { SubscriptionsTab } from './SubscriptionsTab';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
export const PaymentsPage = observer(() => {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const tabsNames = ['subscription', 'payment_information',
  // 'reimbursement_details',
  'invoices'
  // 'ledger',
  // 'pricing_tiers',
  ];
  if (store.account.featureFlagsStore.getIsSubscriptionsAndPaymentsEnabled) {
    tabsNames.unshift(...['subscription2', 'payments2']);
  }
  if (!store.company.companyFeatureStore.disableReimbursementDetails) tabsNames.splice(2, 0, 'reimbursement_details');
  const _useURLHandler = _objectSpread({}, useURLHandler('subscription', tabsNames)),
    handleSelectedTabChange = _useURLHandler.handleSelectedTabChange,
    selectedTab = _useURLHandler.selectedTab;
  const handleTabChange = (e, newValue) => handleSelectedTabChange(newValue);
  const getSelectedTab = () => {
    switch (selectedTab) {
      // case 'ledger':
      //   return <LedgerTab />;
      case 'invoices':
        return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(InvoicesTab, null));
      case 'payment_information':
        return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(PaymentInformationTab, null));
      case 'payments2':
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PaymentMethodsGrid, null));
      // case 'pricing_tiers':
      //   return <PricingTiersTab />;
      case 'reimbursement_details':
        return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ReimbursementDetailsTab, null));
      case 'subscription2':
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubscriptionsTab, null));
      case 'subscription':
      default:
        return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SubscriptionTab, null));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "payments page tabs",
    onChange: handleTabChange,
    position: "sticky",
    type: "navigation",
    value: selectedTab
  }, tabsNames.map(tabName => /*#__PURE__*/React.createElement(Tab, {
    key: tabName,
    label: t("subscriptions.".concat(tabName)),
    value: tabName,
    'custom-attribute': '760-payments-page-' + tabName
  }))), getSelectedTab());
});